<template>
    <div class="login-wrap">
        <img src="../../assets/img/bg.png" alt="" />
        <div class="flex_down1">
            <img src="../../assets/img/login_logo.png" class="img" alt="" />
            <div v-if="!zhuModel">
                <!-- 登录 -->
                <div v-if="!showPass">
                    <div class="flex_column u_alCenter">
                        <span class="span_1">合作伙伴管理后台</span>
                        <span class="span_2"
                            >使用您的HYEBIRD账号登录后台。如果您还没有账号，请点击这里进行<span class="span_3" @click="zhuce"
                                >注册</span
                            ></span
                        >
                    </div>
                    <el-form :model="param" ref="login" label-width="0px" class="ms-content" v-if="!showPass">
                        <el-form-item>
                            <div class="u_email" v-if="blurModel && !param.email">
                                <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="电子邮件地址"> </el-input>
                            </div>
                            <div class="u_email1" v-else>
                                <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="电子邮件地址"> </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="u_password">
                            <div class="u_email" v-if="blurModel1 && !param.password">
                                <el-input
                                    type="password"
                                    show-password
                                    v-model="param.password"
                                    @focus="focus1"
                                    @blur="blur1"
                                    placeholder="密码"
                                >
                                </el-input>
                            </div>
                            <div class="u_email1" v-else>
                                <el-input
                                    type="password"
                                    show-password
                                    v-model="param.password"
                                    @focus="focus1"
                                    @blur="blur1"
                                    placeholder="密码"
                                >
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-button class="login-btn" @click="submitForm()" :loading="loading"> 登录 </el-button>
                        <p class="login-tips" @click="getPassword">忘记密码？</p>
                    </el-form>
                    <div class="flex_column u_poa" @click="zhuce">
                        <span>成为HYEBIRD合作伙伴？</span>
                        <span>点击注册</span>
                    </div>
                </div>
                <!-- 重设密码 -->
                <div v-else>
                    <div class="flex_column u_alCenter">
                        <span class="span_1">重设密码</span>
                    </div>
                    <el-form :model="param" ref="login" label-width="0px" class="ms-content">
                        <el-form-item>
                            <div class="u_email" v-if="blurModel">
                                <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="电子邮件地址"> </el-input>
                            </div>
                            <div class="u_email1" v-else>
                                <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="电子邮件地址"> </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="u_email u_emails" v-if="blurMode2">
                                <el-input v-model="code" @focus="focus2" @blur="blur2">
                                    <div slot="suffix" class="getCode" @click.stop="senderVerficationCode" placeholder="请输入验证码">
                                        获取验证码
                                    </div>
                                </el-input>
                            </div>
                            <div class="u_email1 u_emails" v-else>
                                <el-input v-model="code" @focus="focus2" @blur="blur2" placeholder="请输入验证码">
                                    <div slot="suffix" v-if="show" class="getCode" @click.stop="senderVerficationCode">获取验证码</div>
                                    <div slot="suffix" v-else class="getCode">{{ count }}秒后重发</div>
                                </el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="u_password">
                            <div class="u_email" v-if="blurModel1">
                                <el-input
                                    type="password"
                                    show-password
                                    v-model="param.password"
                                    @focus="focus1"
                                    @blur="blur1"
                                    placeholder="输入新密码"
                                >
                                </el-input>
                            </div>
                            <div class="u_email1" v-else>
                                <el-input
                                    type="password"
                                    show-password
                                    v-model="param.password"
                                    @focus="focus1"
                                    @blur="blur1"
                                    placeholder="输入新密码"
                                >
                                </el-input>
                            </div>
                        </el-form-item>

                        <el-button class="login-btn" @click="resetForm()" :loading="loading"> 提交密码 </el-button>
                    </el-form>
                    <div class="flex_column u_poa" @click="getPassword1">
                        <span>取消修改密码？</span>
                        <span>点击登录</span>
                    </div>
                </div>
            </div>
            <!-- 注册 -->
            <div v-else>
                <div class="flex_column u_alCenter mt151">
                    <span class="span_1">注册账号</span>
                    <span class="span_2 span_235"
                        >感谢您成为HYEBIRD的合作伙伴。如果您已有账号，请点击这里<span class="span_3" @click="getPassword1">登录</span></span
                    >
                </div>
                <el-form :model="param" ref="login" label-width="0px" class="ms-content">
                    <el-form-item>
                        <div class="u_email" v-if="blurModelcompany">
                            <el-input v-model="param.company" @focus="focuscompany" @blur="blurcompany" placeholder="请输入公司名称">
                            </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input v-model="param.company" @focus="focuscompany" @blur="blurcompany" placeholder="请输入公司名称">
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="u_email" v-if="blurModel">
                            <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="请输入电子邮箱"> </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input v-model="param.email" @focus="focus" @blur="blur" placeholder="请输入电子邮箱"> </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="u_email" v-if="blurModelphone">
                            <el-input
                                v-model.number="param.phone"
                                maxlength="11"
                                @focus="focusphone"
                                @blur="blurphone"
                                placeholder="请输入手机号码"
                            >
                            </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input
                                v-model.number="param.phone"
                                maxlength="11"
                                @focus="focusphone"
                                @blur="blurphone"
                                placeholder="请输入手机号码"
                            >
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <div class="u_email u_emails" v-if="blurMode2">
                            <el-input v-model.number="code" @focus="focus2" @blur="blur2">
                                <div slot="suffix" class="getCode" @click.stop="senderVerficationCode" placeholder="请输入验证码">
                                    获取验证码
                                </div>
                                <div slot="suffix" v-if="count" class="getCode">{{ count }}秒后重发</div>
                            </el-input>
                        </div>
                        <div class="u_email1 u_emails" v-else>
                            <el-input v-model.number="code" @focus="focus2" @blur="blur2" placeholder="请输入验证码">
                                <div slot="suffix" v-if="show" class="getCode" @click.stop="senderVerficationCode">获取验证码</div>
                                <div slot="suffix" v-else class="getCode">{{ count }}秒后重发</div>
                            </el-input>
                        </div>
                    </el-form-item>
                    <el-form-item class="u_password">
                        <div class="u_email" v-if="blurModel1">
                            <el-input
                                type="password"
                                show-password
                                v-model="param.password"
                                autocomplete="new-password"
                                @focus="focus1"
                                @blur="blur1"
                                placeholder="请输入账户密码"
                            >
                            </el-input>
                        </div>
                        <div class="u_email1" v-else>
                            <el-input
                                type="password"
                                show-password
                                v-model="param.password"
                                autocomplete="new-password"
                                @focus="focus1"
                                @blur="blur1"
                                placeholder="请输入账户密码"
                            >
                            </el-input>
                        </div>
                    </el-form-item>
                    <div class="u_xie">
                        <img src="../../assets//img/login_dui.png" class="login_dui" alt="" />
                        <span>注册即表示您同意《服务协议》</span>
                    </div>

                    <el-button class="login-btn" @click="register()" :loading="loading"> 快速开通 </el-button>
                </el-form>
                <div class="flex_column u_poa" @click="getPassword1">
                    <span>已有HYEBIRD管理账户？</span>
                    <span>点击登录</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapState } from 'vuex';
export default {
    data: function () {
        return {
            loading: false,
            zhuModel: false, //注册
            blurModel: false,
            blurModel1: false,
            blurMode2: false,
            blurModelphone: false,
            blurModelcompany: false,
            show: true,
            count: '',
            timer: 0,
            showPass: false,
            param: {
                email: '',
                password: '',
                company: '',
                phone: ''
                // [{"key":"company","value":"测试公司","description":"公司","type":"text"}]
                // email: '344887562@qq.com',
                // password: '123456'
            },
            code: ''
        };
    },
    created() {},
    mounted() {},
    // computed: mapState({
    //     name: (state) => state.name,
    //     name1: 'name',
    // }),
    methods: {
        // 失去 获取焦点
        blur() {
            this.blurModel = false;
        },
        focus() {
            this.blurModel = true;
        },
        blur1() {
            this.blurModel1 = false;
        },
        focus1() {
            this.blurModel1 = true;
        },
        blur2() {
            this.blurMode2 = false;
        },
        focus2() {
            this.blurMode2 = true;
        },
        focusphone() {
            this.blurModelphone = true;
        },
        blurphone() {
            this.blurModelphone = false;
        },
        focuscompany() {
            this.blurModelcompany = true;
        },
        blurcompany() {
            this.blurModelcompany = false;
        },
        // 点击注册
        zhuce() {
            this.loading = false;
            this.zhuModel = true;
            this.tong();
        },
        tong() {
            this.param.password = '';
            this.param.email = '';
            this.param.company = '';
            this.param.phone = '';
            this.blurModel = false;
            this.blurModel1 = false;
            this.blurMode2 = false;
            this.blurModelcompany = false;
            this.blurModelphone = false;
            this.code = '';
        },
        // 忘记密码
        getPassword() {
            this.loading = false;
            this.showPass = true;
            this.tong();
        },
        getPassword1() {
            this.loading = false;
            this.showPass = false;
            this.zhuModel = false;
            this.tong();
        },
        senderVerficationCode() {
            if (this.param.email == '') {
                this.$message.error('请输入邮箱');
                return;
            }
            let TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                let timer = 0;
                timer = setInterval(() => {
                    if (this.count > 0 && this.count <= 120) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(timer);
                        timer = 0;
                    }
                }, 1000);

                this.getcode();
            }
        },
        getcode() {
            let that = this;
            let obj = {
                email: that.param.email
            };
            that.$post('/clientapi/send_email_code', obj).then(function (res) {
                if (res.code == 200) {
                    that.$message.success('发送成功');
                } else {
                    that.$message.error(res.msg);
                }
            });
        },
        resetForm() {
            let that = this;
            if (that.param.email == '') {
                that.$message.error('请输入邮箱');
                return;
            }
            if (that.code == '') {
                that.$message.error('请输入验证码');
                return;
            }
            if (that.param.password == '') {
                that.$message.error('请输入密码');
                return;
            }
            that.loading = true;
            let obj = {
                email: that.param.email,
                code: that.code,
                password: that.param.password
            };
            that.$post('/clientapi/forgot_password', obj)
                .then(function (res) {
                    that.loading = false;
                    if (res.code == 200) {
                        that.$message.success('修改成功');
                        that.param = {};
                        that.code = '';
                        that.showPass = false;
                    } else {
                        that.$message.error(res.mag);
                    }
                })
                .catch((err) => {
                    that.loading = false;
                });
        },
        submitForm() {
            let that = this;
            if (that.param.email == '') {
                that.$message.error('请输入邮箱');
                return;
            }
            if (that.param.password == '') {
                that.$message.error('请输入密码');
                return;
            }
            let obj = {
                email: that.param.email,
                password: that.param.password
            };
            that.loading = true;
            that.$refs.login.validate((valid) => {
                if (valid) {
                    that.$get('/clientapi/login', obj)
                        .then(function (res) {
                            if (res.data.is_active) {
                                if (res.data.auth_info.length == 1 && res.data.auth_info[0] == 'pda') {
                                    that.$message.error('该账号只有扫码枪权限');
                                    that.loading = false;

                                    return;
                                }
                                if (res.data.auth_info.length == 0) {
                                    that.$message.error('该账号没有权限');
                                    that.loading = false;
                                    return;
                                }
                                that.$message({
                                    showClose: true,
                                    message: '登录成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        console.log('res.data :>> ', res.data);
                                        localStorage.setItem('pdaToken', res.data.factory_token);
                                        localStorage.setItem('user_type', res.data.staff_type);
                                        localStorage.setItem('token', res.data.token);
                                        localStorage.setItem('full_name', res.data.full_name);
                                        localStorage.setItem('auth_info', JSON.stringify(res.data.auth_info));
                                        localStorage.setItem('role_permission_info', JSON.stringify(res.data.available_auth_info));
                                        that.loading = false;
                                        that.$router.push('/');
                                    }
                                });
                            } else {
                                that.$message.error('该账号还未激活');
                                that.loading = false;
                            }
                        })
                        .catch((err) => {
                            that.loading = false;
                        });
                } else {
                    that.$message.error('请输入邮箱和密码');
                    that.loading = false;
                    return false;
                }
            });
        },
        register() {
            let that = this;
            if (that.param.company == '') {
                that.$message.error('请输入公司名称');
                return;
            }
            if (that.param.email == '') {
                that.$message.error('请输入电子邮箱');
                return;
            }
            if (that.param.phone == '') {
                that.$message.error('请输入手机号码');
                return;
            }
            if (that.code == '') {
                that.$message.error('请输入验证码');
                return;
            }
            if (that.param.password == '') {
                that.$message.error('请输入密码');
                return;
            }

            let obj = {
                email: that.param.email,
                code: that.code,
                password: that.param.password,
                phone: that.param.phone,
                company: that.param.company
            };
            that.loading = true;
            that.$post('/clientapi/register', obj)
                .then(function (res) {
                    that.loading = false;
                    if (res.code == 200) {
                        that.$message.success('注册成功');
                        that.getPassword1();
                    }
                })
                .catch((err) => {
                    that.loading = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.mt151 {
    margin-top: 51px !important;
}
.u_xie {
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    .login_dui {
        width: 16px !important;
        height: 16px !important;
        margin: 0 !important;
    }
    span {
        font-family: ' PingFang SC';
        font-size: 12px;
        font-weight: 500;
        color: rgba(235, 235, 235, 1);
        margin-left: 6px;
        cursor: pointer;
    }
}
.span_3 {
    text-decoration: underline;
    cursor: pointer;
}
.span_235 {
    color: rgba(235, 235, 235, 1) !important;
}
.u_poa {
    align-items: center;
    font-family: ' PingFang SC';
    font-size: 12px;
    font-weight: 500;
    color: rgb(235, 235, 235);

    // bottom: 27px;
    // position: absolute;
    // left: 50%;
    // transform: translate(-50%);
    cursor: pointer;
    // margin-top: 234px ;
    line-height: 18px;
    margin-top: 30px;
}
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: cover;
    background: rgb(33, 33, 33);
    padding: 13px;
    box-sizing: border-box;
    display: flex;
    img {
        width: 49.5%;
        height: auto;
    }
    .flex_down1 {
        display: flex;
        flex-direction: column;
        margin-left: 131px;
        width: 50%;
        align-items: center;
        position: relative;
        .img {
            // width: 68.36px;
            // height: 12.6px;
            width: 68.36px;
            // height: 124.18px;
            margin: 40px 0 0 0;
        }
        .u_alCenter {
            align-items: center;
            margin-top: 151px;
            .span_1 {
                font-family: PingFang SC;
                font-size: 30px;
                font-weight: 500;
                line-height: 46px;
                margin-bottom: 9px;
            }
            .span_2 {
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 500;
                line-height: 22px;
                color: rgba(171, 171, 171, 1);
                margin-bottom: 34px;
            }
        }
    }
}

.getCode {
    width: 74px;
    height: 24px;
    border: 1px solid rgba(54, 54, 54, 1);
    background: rgba(94, 94, 94, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    position: absolute;
    // top: 10px;
    top: 50%;
    transform: translate(0, -50%);
    right: 11px;
    cursor: pointer;
}

/deep/.el-input__inner {
    height: 42px;
    width: 464px;
    border: none !important;
    background: rgba(43, 43, 43, 1) !important;
    font-family: PingFang SC;
    font-size: 14px !important;
    font-weight: 400;
    color: rgb(245, 245, 245) !important;
    box-shadow: none !important;
    padding: 0 10px !important;
}
/deep/.el-input__inner:-webkit-autofill,
.el-input__inner:-webkit-autofill:hover,
.el-input__inner:-webkit-autofill:focus,
.el-input__inner:-webkit-autofill:active {
    -webkit-transition-delay: 99999s;
    -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}

/deep/.u_email .el-input .el-input__inner {
    border: 1px solid rgba(0, 115, 230, 1) !important;
    background: rgba(33, 33, 33, 1) !important;
}
/deep/.u_email1 .el-input .el-input__inner {
    background: rgba(64, 64, 64, 1) !important;
}
/deep/.el-input__inner::placeholder {
    color: rgba(117, 117, 117, 1) !important;
    font-size: 14px !important;
}
.code {
    width: 22.71px;
    height: 25.68px;
}
.password {
    width: 28px;
    height: 28px;
}

.ms-title {
    width: 204.31px;
    height: 93.66px;
    margin-bottom: 39px;
}

.p {
    padding: 24px 0 32px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login-btn {
    text-align: center;
    cursor: pointer;
}

.login-btn {
    width: 464px;
    height: 42px;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    background: rgb(235, 235, 235) !important;
    margin-bottom: 12px;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: rgb(33, 33, 33) !important;
    font-family: PingFang SC !important;
}

/deep/.el-form-item {
    margin-bottom: 12px;
}

/deep/.u_password.el-form-item {
    margin-bottom: 24px;
}

.login-tips {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 10px;
    color: #91d9f2;
    text-align: center;
    color: rgba(235, 235, 235, 1);
    text-decoration: underline;
    text-underline-offset: 1px;
    cursor: pointer;
}

.u_button {
    font-weight: 400;
    font-size: 14px;
    color: rgb(33, 33, 33);
}
</style>
